/*
  This wrapper around the analytics call allows us to check if the onclick handler
  already exists via the displayName before attaching another click handler.
*/
export type CallbackType = {
  (this: GlobalEventHandlers, e: MouseEvent): any;
  displayName?: string;
};

export const DISPLAY_NAME = "selectItemAnalytics";

export const selectItemAnalytics = (callback: CallbackType) => {
  callback.displayName = DISPLAY_NAME;
  return callback;
};

export const getPageType = (resourceType: string, isFeature: boolean) => {
  if (resourceType === "post" && isFeature) {
    return "feature";
  } else if (resourceType === "post") {
    return "story";
  } else if (resourceType === "quickPost") {
    return "quick_post";
  } else {
    return resourceType;
  }
};
